import { useIsOSThemeDark } from "./use-is-os-theme-dark";

export function useIsWireThemeDark(themeEnvironment: "Auto" | "Dark" | "Light" | undefined): boolean {
    const isOSThemeDark = useIsOSThemeDark();
    if (themeEnvironment === "Auto") {
        return isOSThemeDark;
    }
    return themeEnvironment === "Dark";
}
